export default __webpack_public_path__ + "static/media/Economics_01_05.ac5fd518.png";